// 即将弃用 请使用request.ts
import axios from 'axios';
import HdlToast from '@/utils/toast';
import { WHITE_API } from '@/helper/common/constant';
import errorHandle from '@/utils/errorHandle';

const baseURL: string = process.env.NODE_ENV === 'production' ? '/' : '/api'; //生成
const service = axios.create({
  baseURL,
  timeout: 10000,
  withCredentials: true,
});
service.interceptors.request.use(async (config: any) => {
  config.headers = {
    'Content-Type': 'application/json',
    ReqType: 'APPH5',
  };
  return config;
});

service.interceptors.response.use(
  (response) => {
    const {
      data: { code, data, msg },
      config: { url },
    } = response;
    //白名单内的接口，可直接略过下面的code判断  或者 获取微信config配置参数的 也需要直接忽略下面的code判断
    if (
      WHITE_API.has(url || '') ||
      url?.indexOf('CaterWeixin/v2/getJsParams.json') != -1 ||
      url?.indexOf('CaterWeixin/getJsParams.json') != -1
    ) {
      return response.data;
    }
    //成功
    if (code === 200) {
      return data;
    }
    // 异常
    switch (code) {
      case 601:
        return Promise.reject(response);
      case 602:
        return Promise.reject(response);
      case 603:
        return Promise.reject(response);
      case 605:
        return Promise.reject(response);
      default:
        HdlToast.info(msg);
        return Promise.reject(response);
    }
  },
  (error) => {
    errorHandle(error);
    return Promise.reject(error);
  }
);
export default service;
